import { notifications } from '@mantine/notifications'
import type { QueryClient } from '@tanstack/react-query'
import { useQueryClient } from '@tanstack/react-query'

import { INVALIDATE_KEYS } from '@/constants/invalidateGoalQueryKeys.constants'

import { useGoalsServiceGoalsControllerDelete } from '@/__generated__/queries'

function handleSuccess(queryClient: QueryClient) {
  notifications.show({
    color: 'green',
    message: 'Goal has been successfully deleted',
    title: 'Goal deleted',
  })

  INVALIDATE_KEYS.forEach(key =>
    queryClient.invalidateQueries({
      queryKey: [key],
    }),
  )
}

export function useGoalItemDelete(goalId: string) {
  const queryClient = useQueryClient()

  const deleteMutation = useGoalsServiceGoalsControllerDelete({
    onSuccess: () => {
      handleSuccess(queryClient)
    },
  })

  return {
    deleteGoal: () => deleteMutation.mutate({ goalId: +goalId }),
  }
}
